// extracted by mini-css-extract-plugin
module.exports = {"transactionActions":"SectionAction_transactionActions__3l41Y","unflag":"SectionAction_unflag__1R2bp"};